import { SeparatorLine, StyledSeparator } from "@components/separator/Separator.styles";
import styled from "styled-components";

import WriteLine from "../../components/inputs/writeLine";

export const ChartOfAccountsTemplatesWriteLine = styled(WriteLine)`
    font-size: 30px;
    font-weight: bold;
    font-style: italic;
    letter-spacing: 0.3px;
`;